<div class="container aqx-api-detail">
  <i class="fa fa-spin fa-spinner"
     *ngIf="!apiDetail && !isSubscriptionsComplete"></i>
  <h1 *ngIf="apiDetail">
    <img class="aqx-api-image-small"
         *ngIf="apiDetail.thumbnailUrl"
         [src]="getThumbnailUri(apiDetail)">
    {{apiDetail.displayName}}
  </h1>
  <div *ngIf="apiDetail">
    <!--<hr class="mt-3 mb-2">-->
    <h2>
      API Identification
    </h2>
    <div>
      <div class="row">
        <label class="col-sm-2 col-form-label-sm">
          Context
        </label>
        <div class="col-sm-10">
          <div class="form-control-sm form-control-plaintext">
            {{apiDetail.context}}
          </div>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label-sm">
          Version
        </label>
        <div class="col-sm-10">
          <div class="form-control-sm form-control-plaintext">
            {{apiDetail.version}}
          </div>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label-sm">
          Status
        </label>
        <div class="col-sm-10">
          <div class="form-control-sm form-control-plaintext">
            <div class="badge badge-info">
              {{apiDetail.status | titlecase}}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label-sm">
          Updated
        </label>
        <div class="col-sm-10">
          <div class="form-control-sm form-control-plaintext">
            {{apiDetail.lastUpdatedTime | date: 'medium'}}
          </div>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label-sm">
          Created
        </label>
        <div class="col-sm-10">
          <div class="form-control-sm form-control-plaintext">
            {{apiDetail.createdTime | date: 'medium'}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="apiDetail && isSubscriptionsComplete">
    <hr class="mt-3 mb-2">
    <div *ngIf="!isSubscribing && !isUnsubscribing">
      <h2>
        <span *ngIf="subscriptions?.count > 0">
          Subscription
          <span class="badge badge-info ml-2"
                style="font-weight: normal;margin-bottom: 5px;">
            <i class="fas fa-check"></i> Subscribed
          </span>
          <button class="btn btn-primary ml-4"
                  (click)="isUnsubscribing=true">
            Unsubscribe
          </button>
        </span>
        <button class="btn btn-primary"
                *ngIf="subscriptions?.count === 0"
                (click)="isSubscribing=true">
          <!--routerLink="/apis/{{apiDetail.id}}/subscription-create">-->
          Subscribe
        </button>
      </h2>
      <div *ngIf="subscriptionItemSelected">
        <!--<form [formGroup]="form">-->
        <!--<select formControlName="subscriptionItem">-->
          <!--<option *ngFor="let subscriptionItem of subscriptions" [ngValue]="subscriptionItem">-->
            <!--{{ subscriptionItem.id }}-->
          <!--</option>-->
        <!--</select>-->
        <!--</form>-->
        <div class="row">
          <label class="col-sm-2 col-form-label-sm">
            Status
          </label>
          <div class="col-sm-10">
            <div class="form-control-sm form-control-plaintext">
              {{subscriptionItemSelected.status | titlecase}}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label-sm">
            Tier
          </label>
          <div class="col-sm-10">
            <div class="form-control-sm form-control-plaintext">
              {{subscriptionItemSelected.tier}}
            </div>
          </div>
        </div>
        <div>
          <a class="aqx-expand-collapse col-form-label-sm"
             data-toggle="collapse"
             data-target="#advancedModeContainer"
             aria-expanded="false"
             aria-controls="advancedModeContainer">
            Application
          </a>
        </div>
        <div class="collapse card-body" id="advancedModeContainer">
          <div class="row"
               *ngIf="applicationDetail">
            <label class="col-sm-2 col-form-label-sm">
              Application Name
            </label>
            <div class="col-sm-10">
              <div class="form-control-sm form-control-plaintext">
                {{applicationDetail.name}}
              </div>
            </div>
          </div>
          <div class="row"
               *ngIf="applicationDetail">
            <label class="col-sm-2 col-form-label-sm">
              Application Description
            </label>
            <div class="col-sm-10">
              <div class="form-control-sm form-control-plaintext">
                {{applicationDetail.description}}
                <em *ngIf="!applicationDetail.description">none</em>
              </div>
            </div>
          </div>
          <div class="row"
               *ngIf="applicationDetail">
            <label class="col-sm-2 col-form-label-sm">
              Callback URL
            </label>
            <div class="col-sm-10">
              <div class="form-control-sm form-control-plaintext">
                {{applicationDetail.callbackUrl}}
                <em *ngIf="!applicationDetail.callbackUrl">none</em>
              </div>
            </div>
          </div>
        </div>
        <aqx-application-keys
          *ngIf="applicationDetail"
          [environmentsAvailable]="apiDetail.environmentList"
          [exampleResource]="exampleResource"
          [keys]="applicationDetail.keys"
          [invocationUri]="invocationUri">
        </aqx-application-keys>
      </div>
    </div>
  </div>
  <aqx-subscription-manage
    *ngIf="isSubscribing || isUnsubscribing"
    (messageEvent)="receiveMessageFromSubscriptionCreate($event)"
    [apiDetail]="apiDetail"
    [subscriptionId]="subscriptionItemSelected?.subscriptionId"
    [isSubscribing]="isSubscribing"
    [isUnsubscribing]="isUnsubscribing">
  </aqx-subscription-manage>
  <div>
    <hr class="mt-3 mb-2"
        *ngIf="apiDetail && (isSubscriptionsComplete || !isUserEntitledApiStore)">
    <h2 *ngIf="apiDetail && (isSubscriptionsComplete || !isUserEntitledApiStore)">
      API Definition
    </h2>
    <!--<div>-->
    <!--{{apiDefinitionObject | json}}-->
    <!--</div>-->
    <div id="swagger-ui"
         [hidden]="!(isSubscriptionsComplete || !isUserEntitledApiStore)">
    </div>
  </div>
</div>
